export const transformEmptyStringToNull = <T extends Record<string, CustomAny>>(obj: T): T => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => [key, value === '' ? null : value]),
  ) as T;
};
